import type {SankeyNode} from './sankey-node';
import {SankeyPart} from './sankey-part';
import {SerializedSankeyEdge} from './serialized';

export class SankeyEdge extends SankeyPart {
  public declare fromNode: SankeyNode;
  public declare toNode: SankeyNode;

  constructor(serializedEdge: SerializedSankeyEdge) {
    super(serializedEdge);
  }

  get edgeId() {
    return `${this.fromNode.id}${this.toNode.id}`;
  }
}
